import { ColorMap } from "@potoo-modules/constants";
import { IconClassType, IconDict } from "./IconClasses";
import React, { useEffect, useRef, useState } from "react";

//icon component
type IconType = {
  color?: string; //className or colorCode
  name: IconClassType;
  size?: number;
  className?: string;
  preserveGradient?: boolean;
  viewBox?: number;
};

const getIcon = (name: IconClassType, color?: string,preserveGradient?: boolean) => {
  const originalIcon = IconDict[name];
  if (color == undefined || preserveGradient) return originalIcon;
  if (originalIcon.type === "path" || originalIcon.type === "circle") {
    let option: { [key: string]: string } = {};
    if (originalIcon.props.stroke) {
      option["stroke"] = color in ColorMap ? ColorMap[color] : color;
    }
    if (originalIcon.props.fill) {
      option["fill"] = color in ColorMap ? ColorMap[color] : color;
    }
    return React.cloneElement(originalIcon, option);
  } else {
    return React.Children.map(originalIcon.props.children, (child) => {
      let option: { [key: string]: string } = {};
      if (child.props.stroke) {
        option["stroke"] = color in ColorMap ? ColorMap[color] : color;
      }
      if (child.props.fill) {
        option["fill"] = color in ColorMap ? ColorMap[color] : color;
      }

      return React.cloneElement(child, option);
    });
  }
};

const Icon = (props: IconType) => {
  const { color, name, size, className = "", preserveGradient = false, viewBox = 24 } = props;
  
  const [svgColor, setSvgColor] = useState<string>(color ?? "");
  const modifiedIcon = getIcon(name, svgColor, preserveGradient);

  const ref = useRef(null);

  useEffect(() => {
    // preserveGradient가 true면 useEffect 실행하지 않음
    if (preserveGradient) return;
    if (ref.current && color == undefined) {
      // svg 요소의 color 스타일 값 가져오기
      const tmpColor = window.getComputedStyle(ref.current).color;
      setSvgColor(tmpColor);
    } 
  }, []);

  useEffect(() => {
    if (preserveGradient) return;
    if (color) {
      setSvgColor(color);
    }
  }, [color, preserveGradient]);

  return (
    <div
      style={{
        width: size,
        height: size,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      className={className}
      ref={ref}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox={`0 0 ${viewBox} ${viewBox}`}
        fill="none"
        preserveAspectRatio="xMidYMid meet"
      // 241118: ButtonIcon 이슈 때문에 위로 옮김
      // className={className}
      // ref={ref}
      >
        {modifiedIcon}
      </svg>
    </div>
  );
};

export default Icon;
